<template>
  <tr class="slds-hint-parent">
    <!--modifica salvo 10/10/2024-->
    <td>
      <button class="slds-button slds-button_icon" :title="$t('action.copy')" @click="$emit('copy', {id: row.sfmcId})">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="../../assets/symbols.svg#copy"></use>
        </svg>
      </button>
    </td>
    <th :data-label="$t('usersManagement.user.name')" scope="row">
      <div class="slds-truncate" :title="row.name">
        {{ row.name }}
      </div>
    </th>
    <td :data-label="$t('usersManagement.user.email')">
      <div class="slds-truncate" :title="row.email">
        {{ row.email }}
      </div>
    </td>
    <td :data-label="$t('usersManagement.user.sfmcId')">
      <div class="slds-truncate" :title="row.sfmcId">
        {{ row.sfmcId }}
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  created () {
    this.row = this.value
  },
  data () {
    return {
      mode: 'read',
      oldRow: '',
      row: {}
    }
  },
  props: {
    value: Object
  },
  watch: {
    value: {
      handler (value) {
        this.row = value
      },
      deep: true
    }
  }
}
</script>
